import React, { useState } from "react";
import { sidebarData } from "./sidebarData/sidebarData.js";
import { useLocation, useNavigate } from "react-router-dom";
import Logout from "../../../assets/Logout.jsx";
import ConfirmationModal from "../modals/ConfirmationModal.jsx";
import { LogoutApi } from "../../../api/request/auth.js";
import toast from "react-hot-toast";
import { clearCookies } from "../../../services/Cookies.jsx";
import { setloggedIn } from "../../../store/Slices/userSlice.js";
import { useDispatch } from "react-redux";
import "./Sidebar.scss";
import { Sidebar, Menu, SubMenu } from "react-pro-sidebar";

const AppSidebar = ({setIsDrawerOpen}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const getFirstPath = (path) => {
    const parts = path.split("/");
    return parts.length > 1 ? "/" + parts[1] : path;
  };

  const handleMenuClick = (index) => {
    setOpenSubMenuIndex(index);
  };

  const handleClick = (url) => {
    if (!url) return;
    navigate(url);
    if (setIsDrawerOpen) setIsDrawerOpen(false);
  };

  const isActivePath = (path) => {
    let active = false;
    path?.map((item) => {
      if (item == getFirstPath(pathname)) {
        active = true;
      }
    });
    return active;
  };
  const clearAll = () => {
    dispatch(setloggedIn(false));
    clearCookies();
    navigate("/login");
  };
  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi();
      if (data?.status) toast.success(data?.message);
      clearAll();
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      clearAll();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className="sidebar-container w-[280px] fixed border-r">
        <div className="border-b px-4 py-1">
          <div>
            <img
              src="/assets/icons/logo.png"
              alt="logo"
              className="h-16 w-full object-contain"
            />
          </div>
        </div>

        {/* <div className="h-[calc(100vh-158px)] overflow-y-auto pr-4 my-3">
          {sidebarData.map((item, index) => {
            const iconWithProps = item?.icon
              ? React.cloneElement(item?.icon, {
                  active: isActivePath(item?.activeUrl),
                })
              : null;
            return (
              <div
                key={index}
                className="flex items-center gap-3 my-3 mb-5 ps-4"
              >
                <div
                  onClick={() => navigate(item?.url)}
                  className={`font-medium cursor-pointer duration-200 w-full ${
                    isActivePath(item?.activeUrl)
                      ? " text-White bg-primary rounded-lg font-semibold"
                      : null
                  }`}
                >
                  <button className="flex items-center w-full py-2 px-6">
                    {iconWithProps}
                    <p className="text-base ms-3">{item?.title}</p>
                  </button>
                </div>
              </div>
            );
          })}
        </div> */}

        <div className="h-[calc(100vh-158px)] overflow-y-auto pr-4 my-3 mid-title">
          {sidebarData.map((item, index) => {
            const iconWithProps = item?.icon
              ? React.cloneElement(item?.icon, {
                  active: isActivePath(item?.activeUrl),
                })
              : null;

            return item?.children ? (
              <Sidebar key={index}>
                <Menu>
                  <SubMenu
                    open={openSubMenuIndex === index}
                    onOpenChange={() =>
                      handleMenuClick(openSubMenuIndex === index ? null : index)
                    }
                    label={
                      <div className="flex items-center font-medium cursor-pointer py-2 ps-10 header text-secondary">
                        {iconWithProps}
                        <p className="ms-3 text-black">{item?.title}</p>
                      </div>
                    }
                  >
                    <div>
                      {item?.children?.map((childItem, idx) => {
                        const childIconWithProps = React.cloneElement(
                          childItem?.icon,
                          { active: isActivePath(childItem?.activeUrl) }
                        );
                        return (
                          <div
                            key={idx}
                            className="flex items-center gap-3 w-full mt-3"
                          >
                            <div
                              className={`w-1 h-10 rounded-e-md duration-200 ${
                                isActivePath(childItem?.activeUrl)
                                  ? "bg-primary"
                                  : ""
                              }`}
                            ></div>
                            <div
                              onClick={() => handleClick(childItem?.url)}
                              className={`submenu child flex items-center cursor-pointer font-medium py-2 ps-10 mr-4 duration-200 w-full ${
                                isActivePath(childItem?.activeUrl)
                                  ? "text-White bg-primary rounded-lg sub-title"
                                  : ""
                              }`}
                            >
                              {childIconWithProps}
                              <p className="ms-2">{childItem?.title}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </SubMenu>
                </Menu>
              </Sidebar>
            ) : (
              <div key={index} className="flex items-center gap-3 my-3">
                <div
                  className={`w-1 h-10 rounded-e-md duration-200 ${
                    isActivePath(item?.activeUrl) ? "bg-primary" : ""
                  }`}
                ></div>
                <div
                  onClick={() => handleClick(item?.url)}
                  className={`font-medium cursor-pointer duration-200 w-full ${
                    isActivePath(item?.activeUrl)
                      ? "text-White bg-primary rounded-lg sub-title"
                      : "text-secondary"
                  }`}
                >
                  <button className="flex items-center w-full py-2 px-6">
                    {iconWithProps}
                    <p
                      className={`ms-3 ${
                        isActivePath(item?.activeUrl)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      {item?.title}
                    </p>
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="px-4 pb-5">
          <button
            className="btn-primary w-full flex items-center justify-center gap-3"
            onClick={() => setIsModalOpen(true)}
          >
            <Logout />
            <p>Logout</p>
          </button>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message="Are you sure you want to logout?"
        onConfirm={logoutHandler}
        isLoading={isLoading}
        loadingLabel="Loging out..."
      />
    </>
  );
};

export default AppSidebar;
